import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class TargetType extends BaseEntity{

    targetTypeCode : string;
    name : string;
    rank : number;
    isRate : boolean;
    applyToRole : boolean;
    applyToPartner : boolean;
    notationBase : boolean;
    
}
